import Choices from "Choices.js";
import "choices.js/public/assets/styles/choices.css";
import { globalData, globalConf } from "@olmokit/core/data";
import { activeStepOnclick, updateStepparams, deleteStepparamsRetire, getUrlParamGuest } from "components/Checkout";
import { $, $all, forEach, addClass, removeClass, on } from "@olmokit/dom";
import axios from 'axios';
import ScrollToPlugin from "gsap/ScrollToPlugin";
import gsap from "gsap";
gsap.registerPlugin(ScrollToPlugin);
import Alpine from 'alpinejs';
import "./index.scss";

/**
 * Component: CheckoutAddress
 */

const user = globalData.user;
const cmsApiUrl = globalConf.cmsApiUrl;
const cartid = globalData.cartid;
const locale = globalConf.locale;
const route = globalData.route;

const guest = getUrlParamGuest();

const config = {
  headers: {
    ...(!guest) && { "x-token": user.token },
    ...(guest) && { "x-guest": guest },
    "Content-Type": "application/json"
  }
};

const $container = $('.CheckoutAddress:container')

export function CheckoutAddressUnique() {
  console.log("CheckoutAddress mounted.");

  const $sameAddress = $('#validationText06')
  const $company = $('#validationText07')
  const $invoiceElectric = $('#validationText08')
  const $billingFields = $('.billingFileds')
  const $shippingFields = $('.shippingFields')
  const $sameAsShipping = $('.sameAsShipping')
  const $retire = $all("input[type=radio][name=shippingmethod]");
  const $retireVal = $("input[value=retire]");

  const $companyField = $('#company')
  const $cfpiva = $('#cfpiva');
  const $pec = $('#pec');
  const $pivacode = $('#pivacode');
  const $einvoce = $('#einvoice');

  const $validationText08 = $('#validationText08');
  if($validationText08.value == 'true'){
    $validationText08.checked = true
    $einvoce.value = 'true'
  }  

  const $validationText07 = $('#validationText07');
  if($validationText07.value == 'true'){
    $validationText07.checked = true

    removeClass($companyField, 'hidden')
    const $inputCompanyField = $('input', $companyField);
    $inputCompanyField.required = true
    removeClass($cfpiva, 'hidden')
    const $inputCfpiva = $('input', $cfpiva);
    $inputCfpiva.required = true
    removeClass($pec, 'hidden')
    const $inputPec = $('input', $pec);
    $inputPec.required = true
    removeClass($pivacode, 'hidden')
    const $inputPivacode = $('input', $pivacode);
    $inputPivacode.required = true       
  }  

  forEach($retire, (retire) => {
    on(retire, 'change', () => {
      const val = retire.value
      if (val == 'retire') {
        goForFieldShipping(true)
      } else {
        goForFieldShipping(false)
      }
    })
  })

  if ($retireVal.checked) {
    goForFieldShipping(true)
  } else {
    goForFieldShipping(false)
  }

  // const element = document.querySelector('.city');
  // new Choices(element);

  const shipping = globalData.shipping;
  const billing = globalData.billing;
  const acc = $all(".step");
  const $errors = $('.CheckoutAddresses:error');

  const cartShippingStorage = localStorage.getItem("cart-shipping");
  const cartShipping = JSON.parse(cartShippingStorage);
  if (cartShipping && route != 'profile') {
    if (cartShipping[1] == 'retire') {
      const $checkoutAddressesShipping = $('.CheckoutAddresses:shipping');
      addClass($checkoutAddressesShipping, 'noAddressShipping');
    }
  }

  goForFieldBilling()

  on($sameAddress, 'change', (el) => {
    console.log('el.checked', $sameAddress.checked);

    if($sameAddress.checked){
      $company.disabled = true;
      $invoiceElectric.disabled = true;
    } else {
      $company.disabled = false;
      $invoiceElectric.disabled = false;
    }
    goForFieldBilling()
  })

  on($invoiceElectric, 'change', (el) => {
    if($invoiceElectric.checked){
      $einvoce.value = 'true'
    } else {
      $einvoce.value = 'false'
    }
  })

  on($company, 'change', (el) => {
    console.log('el.company', $company.checked);

    if($company.checked){
      removeClass($companyField, 'hidden')
      const $inputCompanyField = $('input', $companyField);
      $inputCompanyField.required = true
      removeClass($cfpiva, 'hidden')
      const $inputCfpiva = $('input', $cfpiva);
      $inputCfpiva.required = true
      removeClass($pec, 'hidden')
      const $inputPec = $('input', $pec);
      $inputPec.required = true
      removeClass($pivacode, 'hidden')
      const $inputPivacode = $('input', $pivacode);
      $inputPivacode.required = true      
    } else {
      addClass($companyField, 'hidden')
      const $inputCompanyField = $('input', $companyField);
      $inputCompanyField.required = true      
      addClass($cfpiva, 'hidden')
      const $inputCfpiva = $('input', $cfpiva);
      $inputCfpiva.required = false      
      addClass($pec, 'hidden')
      const $inputPec = $('input', $pec);
      $inputPec.required = false      
      addClass($pivacode, 'hidden')
      const $inputPivacode = $('input', $pivacode);
      $inputPivacode.required = false      
    }
    goForFieldBilling()
  })

  const $forwardCheckEmail = $('#CheckoutAddress:forward');
  on($forwardCheckEmail, 'click', (e) => {
    e.preventDefault()
    goForward();
  })

  const $backwwardCheckEmail = $('#CheckoutAddress:backward');
  on($backwwardCheckEmail, 'click', (e) => {
    goBackward();
  })

  function goForFieldShipping(val) {
    if (val) {
      $shippingFields.style.display = 'none'
      $sameAsShipping.style.display = 'none'
      $("[name='name']").removeAttribute('required')
      $("[name='surname']").removeAttribute('required')
      $("[name='phone']").removeAttribute('required')
      $("[name='address']").removeAttribute('required')
      $("[name='number']").removeAttribute('required')
      $("[name='city']").removeAttribute('required')
      $("[name='zip']").removeAttribute('required')
      $("[name='provincia']").removeAttribute('required')
    } else {
      $shippingFields.style.display = 'block'
      $sameAsShipping.style.display = 'block'
      $("[name='name']").setAttribute('required', 'true')
      $("[name='surname']").setAttribute('required', 'true')
      $("[name='phone']").setAttribute('required', 'true')
      $("[name='address']").setAttribute('required', 'true')
      $("[name='number']").setAttribute('required', 'true')
      $("[name='city']").setAttribute('required', 'true')
      $("[name='zip']").setAttribute('required', 'true')
      $("[name='provincia']").setAttribute('required', 'true')
    }
  }

  function shippingRemoveValues() {
    $("[name='name']").value = ''
    $("[name='surname']").value = ''
    $("[name='phone']").value = ''
    $("[name='address']").value = ''
    $("[name='number']").value = ''
    $("[name='city']").value = ''
    $("[name='zip']").value = ''
    $("[name='provincia']").value = ''
  }

  function shippingAddValues(fields) {
    $("[name='name']").value = fields.name
    $("[name='surname']").value = fields.surname
    $("[name='phone']").value = fields.phone
    $("[name='address']").value = fields.address
    $("[name='number']").value = fields.number
    $("[name='city']").value = fields.city
    $("[name='zip']").value = fields.zip
    $("[name='provincia']").value = fields.provincia
  }

  function goForFieldBilling() {
    if ($sameAddress.checked) {
      $billingFields.style.display = 'none'
      $("[name='namebilling']").removeAttribute('required')
      $("[name='surnamebilling']").removeAttribute('required')
      $("[name='phonebilling']").removeAttribute('required')
      $("[name='addressbilling']").removeAttribute('required')
      $("[name='numberbilling']").removeAttribute('required')
      $("[name='citybilling']").removeAttribute('required')
      $("[name='zipbilling']").removeAttribute('required')
      $("[name='provinciabilling']").removeAttribute('required')
    } else {
      $billingFields.style.display = 'block'
      $("[name='namebilling']").setAttribute('required', 'true')
      $("[name='surnamebilling']").setAttribute('required', 'true')
      $("[name='phonebilling']").setAttribute('required', 'true')
      $("[name='phonebilling']").setAttribute('required', 'true')
      $("[name='addressbilling']").setAttribute('required', 'true')
      $("[name='numberbilling']").setAttribute('required', 'true')
      $("[name='citybilling']").setAttribute('required', 'true')
      $("[name='zipbilling']").setAttribute('required', 'true')
      $("[name='provinciabilling']").setAttribute('required', 'true')
    }
  }

  function goForward() {

    // removeClass(acc[2].nextElementSibling, 'activeStep');
    // removeClass(acc[2], 'active');

    const dataShipping = {
      "_type": ["shipping"],
      "name": $("[name='name']").value,
      "surname": $("[name='surname']").value,
      // "company": $("[name='company']").value,
      "provincia": $("[name='provincia']").value,
      "phone": $("[name='phone']").value,
      "address": $("[name='address']").value,
      "number": $("[name='number']").value,
      "city": $("[name='city']").value,
      "zip": $("[name='zip']").value,
      "country": "it",
      "state": $("[name='provincia']").value,
      // "vat": $("[provincia]")
    }

    const dataBilling = {
      "_type": ["billing"],
      "name": $("[name='namebilling']").value,
      "surname": $("[name='surnamebilling']").value,
      // "company": $("[name='company']").value,
      "provincia": $("[name='provinciabilling']").value,
      "phone": $("[name='phonebilling']").value,
      "address": $("[name='addressbilling']").value,
      "number": $("[name='numberbilling']").value,
      "city": $("[name='citybilling']").value,
      "zip": $("[name='zipbilling']").value,
      "cfpiva": $("[name='cfpiva']").value,
      "pec": $("[name='pec']").value,
      "pivacode": $("[name='pivacode']").value,
      "einvoice": $("[name='einvoice']").value,
      "company": $("[name='company']").value
    }

    let counter = 0;

    const $inputCompanyField = $('input', $companyField);
    $inputCompanyField.required = true    

    for (const [key, value] of Object.entries(dataShipping)) {
      if (value == '' && !$retireVal.checked) {
        addClass($container, 'was-validated');
        console.log('key', key);
        counter++
      }
    }

    if($company.checked){
      for (const [key, value] of Object.entries(dataBilling)) {
        if (value == '' && !$sameAddress.checked) {
          addClass($container, 'was-validated');
          console.log('key', key);
          counter++
        }
      }
    } else {
      const compField = ["cfpiva", "pec", "pivacode", "einvoice", "company"]
      for (const [key, value] of Object.entries(dataBilling)) {
        if (value == '' && !$sameAddress.checked && !compField.includes(key)) {
          addClass($container, 'was-validated');
          console.log('key', key);
          counter++
        }
      }      
    }

    const ele = $all(".form-check-input[name='addresses_shipping']");
    let shippingSaved = null;
    for(var i=0;i<ele.length;i++) {
      if(ele[i].checked){
        shippingSaved = ele[i].value
      }
    }    

    console.log('counter', counter);
    console.log('$retireVal.checked', $retireVal.checked);
    console.log('shippingSaved', shippingSaved);    

    if (!counter && $retireVal.checked && !shippingSaved) {
      /**
       * Just billing, No shipping, cause retire in home
       */
      axios.post(cmsApiUrl + '/address', dataBilling, config).then((e) => {
        const { data } = e;
        console.log('data response', data);

        requestIds('retire', data['id'])
      }).catch(error => {

      });
    } else if (!counter && $sameAddress.checked && !shippingSaved) {
      /**
       * Just New shipping, cause billing has the same address
       */
      axios.post(cmsApiUrl + '/address', dataShipping, config).then((e) => {
        const { data } = e;
        console.log('data response', data);

        requestIds(data['id'], data['id'])
      }).catch(error => {

      });
    } else if (!counter && !$sameAddress.checked && !shippingSaved) {
      console.log('New shipping, New billing')
      /**
       * New shipping, New billing
       */      
      axios.all([
        axios.post(cmsApiUrl + '/address', dataShipping, config),
        axios.post(cmsApiUrl + '/address', dataBilling, config)
      ])
        .then(axios.spread((data1, data2) => {
          // output of req.
          console.log('data1', data1, 'data2', data2)
          requestIds(data1['data']['id'], data2['data']['id'])
        }));
    } else if (!counter && $sameAddress.checked && shippingSaved) {
      /**
       * Old shipping, same billing
       */
      requestIds(shippingSaved, shippingSaved)

    } else if (!counter && !$sameAddress.checked && shippingSaved) {
      /**
       * Old shipping, same address
       */
      axios.post(cmsApiUrl + '/address', dataBilling, config).then((e) => {
        const { data } = e;
        console.log('data response', data);

        requestIds(shippingSaved, data['id'])
      }).catch(error => {

      });

    }

  }

  function requestIds(shipping, billing) {

    const data = {
      shipping: shipping,
      billing: billing,
      cart_id: cartid,
      shipping_type: $retire.checked ? 'retire' : 'shipped'
    };

    console.log('data', data);

    removeClass(acc[2].nextElementSibling, 'activeStep');
    removeClass(acc[2], 'active');

    axios.post(cmsApiUrl + '/' + locale + '/shoppingcart/addresses', data, config).then((e) => {
      const { data } = e;
      addClass(acc[3].nextElementSibling, 'activeStep');
      activeStepOnclick(3);
      updateStepparams({ step: 3 });
      removeClass($errors, 'showError');

      gsap.to(window, { duration: 0.3, scrollTo: { y: acc[3], offsetY: 71 } });

      localStorage.setItem("cart-address", JSON.stringify(data));
    }).catch(error => {

      addClass(acc[2].nextElementSibling, 'activeStep');
      addClass(acc[2], 'active');
      addClass($errors, 'showError');

    });
  }

  function goBackward() {

    removeClass(acc[2].nextElementSibling, 'activeStep');
    removeClass(acc[2], 'active');
    removeClass($errors, 'showError');

    activeStepOnclick(1);
    updateStepparams({ step: 1 });
    deleteStepparamsRetire();

    gsap.to(window, { duration: 0.5, scrollTo: { y: acc[1], offsetY: 90 } });

  }

  Alpine.store('addresses', {
    shipping: shipping,
    billing: billing,
    guest: guest ? true : false,
    shippingSelect: '',

    selectshipping(id, fields) {
      this.shippingSelect = id
      shippingAddValues(fields)
    },

    removeselection(id, fields) {
      this.shippingSelect = id
      shippingRemoveValues()

      const ele = $all(".form-check-input[name='addresses_shipping']");
      for(var i=0;i<ele.length;i++) {
        ele[i].checked = false;
      }
    }

  });

  Alpine.start();

}